var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-logo-wrapper",attrs:{"title":"Courtesy of Seabrokers - The shipbroker with a difference"},on:{"click":function($event){return _vm.window.open(`https://www.seabrokers.co.uk/shipping/`, `_blank`)}}},[_c('img',{staticStyle:{"max-width":"200px"},attrs:{"src":require('@/assets/images/seabrokers-group-logo- small.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }